/*
 * @Author: Q in
 * @Date: 2026-04-08 15:25:31
 * @LastEditors: Q in 
 * @LastEditTime: 2026-04-25 10:36:28
 * @FilePath: /new_kefu_pc/src/components/toast/plugin.js
 * @Description: Toast 插件
 */
// plugin.js
import Vue from 'vue';
import ToastComponent from './index.vue';

let toastInstance = null;
let ToastConstructor = null;

const ToastPlugin = {
	install(Vue, options = {}) {
		// 创建 Toast 组件实例
		const initToast = () => {
			if (!ToastConstructor) {
				ToastConstructor = Vue.extend(ToastComponent);
			}

			if (!toastInstance) {
				toastInstance = new ToastConstructor();
				const mountNode = document.createElement('div');
				document.body.appendChild(mountNode);
				toastInstance.$mount(mountNode);
			}
			return toastInstance;
		};

		// 定义全局方法
		const $toast = {
			// 基础显示
			show(config) {
				const instance = initToast();
				instance.show(config);
				return instance;
			},

			// 成功提示
			success(message, duration = 2000, position = 'center') {
				return this.show({ message, type: 'success', duration, position });
			},

			// 错误提示
			error(message, duration = 2000, position = 'center') {
				return this.show({ message, type: 'error', duration, position });
			},

			// 警告提示
			warning(message, duration = 2000, position = 'center') {
				return this.show({ message, type: 'warning', duration, position });
			},

			// 信息提示
			info(message, duration = 2000, position = 'center') {
				return this.show({ message, type: 'default', duration, position });
			},

			// 加载中（不自动关闭）
			loading(message = '加载中...', position = 'center') {
				return this.show({ message, type: 'loading', duration: 0, position });
			},

			// 手动隐藏
			hide() {
				if (toastInstance) {
					toastInstance.hide();
				}
			}
		};

		// 挂载到 Vue 原型
		Vue.prototype.$toast = $toast;

		// 全局属性
		Vue.toast = $toast;
	}
};

export default ToastPlugin;
